var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLogo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120.8 133.1",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "  \n\t.st0{fill:#F37920;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.3 0.2v48h92.1V28.3H18.9V0.2H0.3zM28.5 0v19.9h73.3v36.6H0v76.6h92.4v-19.7H18.9v-37h101.9V0H28.5zM28.3 85v19.7h73.3v28.4h19V85H28.3z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logo.ccd9465d.svg";
export { ForwardRef as ReactComponent };